import React, { useEffect, useState } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  FormControl,
  FormLabel,
  Input,
  ChakraProvider,
  useToast,
  HStack,
  Divider,
  Spacer,
} from '@chakra-ui/react';
import { AppDispatch, Store } from '../Store/StoreInit';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import { useMsal } from '@azure/msal-react';
import { fetchHealthPlanTypeList } from '../Store/GetDropDownsValuesReducer';
import { IHealthPlanType } from '../Infrastructure/Interfaces';

interface Props {
  isOpen?: any;
  onOpen?: any;
  onClose?: any;
}

const HealthPlanTypeModalPoupup: React.FC<Props> = (props: Props) => {
  const dispatch = useDispatch<AppDispatch>();
  const [saveButtonLoading, setSaveButtonLoading] = useState(false);
  const toast = useToast();
  const { accounts } = useMsal();
  const userdetails = JSON.parse(localStorage.getItem('userdetails') || '');
  const userid =
    userdetails[0].portal_Id != ''
      ? userdetails[0].portal_Id
      : accounts[0].username;
  const [isHealthPlanTypeRequired, setIsHealthPlanTypeRequired] =
    useState(false);
  const healthplantypelist: IHealthPlanType[] = useSelector((state: any) => {
    return state.healthPlanTypeList.healthPlanTypeList;
  });

  const [data, setdata] = useState({
    healthPlanTypeId: 0,
    healthPlanType: '',
    createdBy: '',
    createdOn: '0001-01-01T00:00:00',
    modifiedBy: '',
    modifiedOn: '0001-01-01T00:00:00',
  });

  useEffect(() => {
    Store.subscribe(() => {
      setIsHealthPlanTypeRequired(false);
      setdata({
        ...data,
        healthPlanTypeId:
          Store.getState().setHealthPlanTypeItem.value.healthPlanTypeId,
        healthPlanType:
          Store.getState().setHealthPlanTypeItem.value.healthPlanType,
        createdBy: Store.getState().setHealthPlanTypeItem.value.createdBy,
        createdOn: Store.getState().setHealthPlanTypeItem.value.createdOn,
        modifiedBy: Store.getState().setHealthPlanTypeItem.value.modifiedBy,
        modifiedOn: Store.getState().setHealthPlanTypeItem.value.modifiedOn,
      });
    });
  }, []);

  const handleChange = (e: any) => {
    e.preventDefault();
    const { id, value } = e.target;
    setdata({
      ...data,
      [id]: value,
    });
  };

  async function handleSubmit(e: { preventDefault: () => void }) {
    e.preventDefault();

    if (data.healthPlanType.trim() === '') {
      setIsHealthPlanTypeRequired(true);
      return;
    }

    if (data.healthPlanTypeId > 0) {
      var item: any = healthplantypelist.find(
        x => x.healthPlanType == data.healthPlanType.trim()
      );

      if (item != undefined) {
        if (item.healthPlanTypeId != data.healthPlanTypeId) {
          showToast(
            'Error!',
            data.healthPlanType +
              ' already exists. Please use a different name for a Health Plan type.',
            'error'
          );
          return;
        }
      }
    }

    setSaveButtonLoading(true);

    const payload = {
      healthPlanTypeId: data.healthPlanTypeId,
      healthPlanType: data.healthPlanType.trim(),
      createdBy: userid,
      createdOn: '0001-01-01T00:00:00',
      modifiedBy: userid,
      modifiedOn: '0001-01-01T00:00:00',
    };

    const tokenurl = process.env.REACT_APP_TOKEN_URL_SIS as string;
    const baseurl = process.env.REACT_APP_SERVER_BASE_URL as string;

    try {
      const res = await axios.get(tokenurl);
      if (res.data.success) {
        const url = `${baseurl}/Payer/${
          data.healthPlanTypeId > 0
            ? 'update_healthplantype'
            : 'add_healthplantype'
        }`;

        const axiosMethod = data.healthPlanTypeId > 0 ? axios.put : axios.post;

        const response = await axiosMethod(url, JSON.stringify(payload), {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${res.data.token}`,
          },
        });

        setSaveButtonLoading(false);
        dispatch(fetchHealthPlanTypeList());
        props.onClose();

        if (response.data.success) {
          showToast(
            'Success',
            fetchHealthPlanTypeList + ' ' + response.data.message,
            'success'
          );
        }
      }
    } catch (error: any) {
      setSaveButtonLoading(false);
      showToast(
        'Error!',
        error.response.data.message || error.message,
        'error'
      );
    }
  }

  function showToast(
    title: string,
    description: string,
    status: 'info' | 'warning' | 'success' | 'error' | 'loading' | undefined
  ) {
    toast({
      title,
      description,
      position: 'top',
      status,
      duration: status === 'error' ? 10000 : 5000,
      isClosable: true,
    });
  }

  return (
    <>
      <ChakraProvider>
        <Modal
          closeOnOverlayClick={false}
          size={'3xl'}
          isOpen={props.isOpen}
          onClose={props.onClose}
        >
          <ModalOverlay />
          <ModalContent top={20}>
            <form onSubmit={handleSubmit}>
              <ModalHeader fontWeight="bold">
                <u>Health Plan Type</u>
              </ModalHeader>
              <ModalCloseButton color="black" />{' '}
              <ModalBody>
                <FormControl
                  mt={2}
                  isRequired
                  isInvalid={isHealthPlanTypeRequired}
                >
                  <HStack>
                    <FormLabel width="40%" ml="10px" fontWeight="bold">
                      Health Plan Type:
                    </FormLabel>
                    <Input
                      size="sm"
                      maxLength={100}
                      id="healthPlanType"
                      placeholder="Health Plan Type"
                      defaultValue={data.healthPlanType}
                      onChange={e => handleChange(e)}
                    />
                  </HStack>
                </FormControl>
                <Divider mt={2} />
              </ModalBody>
              <ModalFooter>
                <Button bg="#002677" color="white" onClick={props.onClose}>
                  Cancel
                </Button>
                <Spacer />
                <Button
                  isLoading={saveButtonLoading}
                  bg="#002677"
                  color="white"
                  mr={3}
                  type="submit"
                >
                  Save
                </Button>
              </ModalFooter>
            </form>
          </ModalContent>
        </Modal>
      </ChakraProvider>
    </>
  );
};

export default HealthPlanTypeModalPoupup;
